<template>
  <div class="flex flex-col mt-6" :class="{ 'gap-6': props.showBenefits }">
    <template v-if="!props.showPrivacyOnly">
      <p class="text-body2">
        {{ content.PRIVACY_SECTION_CONTENT.PRIVACY_TEXT }} 
        <a href="#" class="underline font-medium hover:no-underline" @click.prevent="isPrivacyVisible = true">
          {{ content.PRIVACY_SECTION_CONTENT.PRIVACY_LINK_TEXT }}
        </a>.<span v-if="props.showIsCreditBrokerMsg"> Car Finance 247 Limited is a credit broker not a lender.</span> 
      </p>
      <div>
        <Benefits v-if="props.showBenefits" />
      </div>
    </template>
    
    <Modal v-show="props.showPrivacyOnly || isPrivacyVisible" @close="closeModal">
      <template v-slot:body>
        <section class="text-black privacy">
          <h1 class="text-h2 text-center font-bold my-4">
            {{ content.PRIVACY_SECTION_CONTENT.PRIVACY_MODAL_TITLE }}
          </h1>
          <div v-if="isLoading">{{ content.PRIVACY_SECTION_CONTENT.LOADING_TEXT }}</div>
          <div v-else-if="error">{{ content.PRIVACY_SECTION_CONTENT.ERROR_TEXT }}</div>
          <div v-else-if="contents && contents.length > 0">
            <div v-for="(item, index) in contents" :key="index">
              <section v-for="(content, idx) in item" :key="idx" v-html="content.content1">
              </section>
            </div>
          </div>
        </section>
      </template>
      <Terms />
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import Terms from '@/components/Terms.vue';
import { usePrivacyPolicy } from '@/composables/useDotCMSContent';
// import * as content from '@/constants/content';
import Benefits from '@/components/Benefits.vue';
import { useConfigStore } from '@/stores/modules/configStore';
import { withDefaults } from 'vue';

const content = useConfigStore().affiliateConfig.contents;

const props = withDefaults(defineProps<{
  showPrivacyOnly?: boolean;
  showBenefits?: boolean;
  showIsCreditBrokerMsg?: boolean;
}>(), {
  showBenefits: true,
  showIsCreditBrokerMsg: false
});

onMounted(() => {
  console.log(props.showPrivacyOnly)
});

const isPrivacyVisible = ref(props.showPrivacyOnly || false);
const { data: contents, isLoading, error } = usePrivacyPolicy();

const emit = defineEmits(['close']);

const closeModal = () => {
  isPrivacyVisible.value = false;
  emit('close');
};
</script>

<style lang="scss">
.privacy{
  text-align: left;
}
.privacy ol {
  margin-left: 1.5rem;
  list-style-type: decimal;
}
.privacy ul {
  margin-left: 1.5rem;
  list-style-type: disc;
  background-color: transparent;
}
.privacy ul li, .terms ol li {
  padding-left: .5rem;
  padding-bottom: .5rem;
}
.privacy ul ::marker, ol ::marker {
  color: #6905F2;
}
</style> 